import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { 
//   faDatabase, faStethoscope, faClipboardCheck, faMoneyBillWave, faGift, faExclamationTriangle, faMinusCircle, faBed, 
//   faBandAid, faMapMarkerAlt,faMoneyCheck, faBullhorn, faChalkboardTeacher, faTasks, faUserSlash, faClock, faAmbulance, faCertificate,
//   faIdCard
// } from '@fortawesome/free-solid-svg-icons';

const SprintCentralEVM = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Learning & Development");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };
 
  const [bac, setBac] = useState(1000);
  const [plannedPercent, setPlannedPercent] = useState(50);
  const [actualPercent, setActualPercent] = useState(40);
  const [ac, setAc] = useState(600);
  const [pd, setPd] = useState(10);
  const [at, setAt] = useState(6);

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">ThinkEVM</div>
          <div className="text-sm lg:text-lg font-bold text-gray-00">Earned Value Management</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}
      <div className="min-h-[80vh] p-4 space-y-6">
        <div className="bg-gray-900 border border-gray-700 rounded-xl p-4 grid grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <label className="text-sm text-gray-300">BAC (Total Budget)</label>
            <input type="number" value={bac} onChange={(e)=>setBac(+e.target.value)} className="p-2 rounded bg-black border border-gray-700"/>
          </div>

          <div className="flex flex-col">
            <label className="text-sm text-gray-300">Planned %</label>
            <input type="number" value={plannedPercent} onChange={(e)=>setPlannedPercent(+e.target.value)} className="p-2 rounded bg-black border border-gray-700"/>
          </div>

          <div className="flex flex-col">
            <label className="text-sm text-gray-300">Actual %</label>
            <input type="number" value={actualPercent} onChange={(e)=>setActualPercent(+e.target.value)} className="p-2 rounded bg-black border border-gray-700"/>
          </div>

          <div className="flex flex-col">
            <label className="text-sm text-gray-300">Actual Cost (AC)</label>
            <input type="number" value={ac} onChange={(e)=>setAc(+e.target.value)} className="p-2 rounded bg-black border border-gray-700"/>
          </div>

          <div className="flex flex-col">
            <label className="text-sm text-gray-300">Planned Duration (PD)</label>
            <input type="number" value={pd} onChange={(e)=>setPd(+e.target.value)} className="p-2 rounded bg-black border border-gray-700"/>
          </div>

          <div className="flex flex-col">
            <label className="text-sm text-gray-300">Actual Time (AT)</label>
            <input type="number" value={at} onChange={(e)=>setAt(+e.target.value)} className="p-2 rounded bg-black border border-gray-700"/>
          </div>

        </div>

        {(() => {
          const PV = (plannedPercent / 100) * bac || 0;
          const EV = (actualPercent / 100) * bac || 0;

          const CV = EV - ac;
          const SV = EV - PV;

          const CPI = ac ? EV / ac : 0;
          const SPI = PV ? EV / PV : 0;

          const EAC = CPI ? bac / CPI : 0;
          const ETC = EAC - ac;
          const VAC = bac - EAC;

          const TCPI = (bac - ac) ? (bac - EV) / (bac - ac) : 0;

          // Earned Schedule (approx)
          const ES = SPI * at;
          const SPI_t = at ? ES / at : 0;
          const SV_t = ES - at;
          const EAC_t = SPI_t ? pd / SPI_t : 0;
          const Delay = at - ES;

          const getColor = (val, good=true) => {
            if (val === 0) return "text-gray-400";
            if (good) return val >= 1 ? "text-green-400" : "text-red-400";
            return val <= 0 ? "text-green-400" : "text-red-400";
          };

          const insights = [];
          if (CPI < 1) insights.push("⚠️ Over Budget");
          if (SPI < 1) insights.push("⚠️ Behind Schedule (EVM)");
          if (SPI_t < 1) insights.push("🚨 Behind Schedule (Real)");
          if (TCPI > 1.2) insights.push("⚠️ Aggressive recovery needed");
          if (Delay > 0) insights.push(`⏳ Delay: ${Delay.toFixed(1)} time units`);

          return (
            <>
              {/* 🔹 KPI CARDS */}
              <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">

                <div className="bg-gray-900 p-3 rounded-xl border border-gray-700">
                  <div className="text-xs text-gray-400">CPI</div>
                  <div className={`text-xl font-bold ${getColor(CPI)}`}>{CPI.toFixed(2)}</div>
                </div>

                <div className="bg-gray-900 p-3 rounded-xl border border-gray-700">
                  <div className="text-xs text-gray-400">SPI</div>
                  <div className={`text-xl font-bold ${getColor(SPI)}`}>{SPI.toFixed(2)}</div>
                </div>

                <div className="bg-gray-900 p-3 rounded-xl border border-gray-700">
                  <div className="text-xs text-gray-400">SPI(t)</div>
                  <div className={`text-xl font-bold ${getColor(SPI_t)}`}>{SPI_t.toFixed(2)}</div>
                </div>

                <div className="bg-gray-900 p-3 rounded-xl border border-gray-700">
                  <div className="text-xs text-gray-400">EAC</div>
                  <div className="text-xl font-bold text-yellow-300">{EAC.toFixed(0)}</div>
                </div>

                <div className="bg-gray-900 p-3 rounded-xl border border-gray-700">
                  <div className="text-xs text-gray-400">Delay</div>
                  <div className={`text-xl font-bold ${getColor(Delay, false)}`}>{Delay.toFixed(1)}</div>
                </div>

              </div>

              {/* 🔹 INSIGHTS */}
              <div className="bg-black text-white border border-yellow-500 rounded-xl p-4">
                <div className="text-sm font-semibold mb-2">Insights</div>
                {insights.length === 0 ? (
                  <div className="text-green-300">✅ Project on track</div>
                ) : (
                  <ul className="list-disc pl-5 text-sm space-y-1">
                    {insights.map((i, idx) => <li className="text-gray-100" key={idx}>{i}</li>)}
                  </ul>
                )}
              </div>

              {/* 🔹 OPTIONAL DETAILS */}
              <div className="bg-gray-900 border border-gray-700 rounded-xl p-4 text-xs grid grid-cols-2 lg:grid-cols-4 gap-3">
                <div>PV: {PV.toFixed(0)}</div>
                <div>EV: {EV.toFixed(0)}</div>
                <div>CV: {CV.toFixed(0)}</div>
                <div>SV: {SV.toFixed(0)}</div>
                <div>VAC: {VAC.toFixed(0)}</div>
                <div>ETC: {ETC.toFixed(0)}</div>
                <div>TCPI: {TCPI.toFixed(2)}</div>
                <div>SV(t): {SV_t.toFixed(1)}</div>
              </div>
            </>
          );
        })()}

      </div>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SprintCentralEVM;
